export const copyRichText = (text: string) => {
  const listener = (ev: ClipboardEvent) => {
    ev.preventDefault()
    ev.clipboardData.setData('text/html', text)
    ev.clipboardData.setData('text/plain', replaceHtml(text))
  }
  document.addEventListener('copy', listener)
  document.execCommand('copy')
  document.removeEventListener('copy', listener)
}

const replaceHtml = (text: string) => {
  return text
    .replaceAll(/<br\/?>/g, '\n') // all br
    .replaceAll(/<li>/g, '\n') // opening li
    .replaceAll(/<\/?span>/g, '') // replace all spans
    .replaceAll(/<\/?strong>/g, '') // replace all strong
    .replaceAll(/<\/?ul>/g, '') // all closing ul
    .replaceAll(/<\/li>/g, '') // all closing li
}
